import type { GetQuartiersQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { quartiersParCommune } from '~/msw/mocks/quartier/quartiers'

export function getQuartiersHandler() {
  return http.get<never, never, GetQuartiersQueryResponse>('http://localhost:3000/api/v1/quartiers', ({ request }) => {
    const codeInsee = new URL(request.url).searchParams.get('codeInsee') ?? ''
    return HttpResponse.json(quartiersParCommune[codeInsee] ?? [])
  })
}
